import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required, email, helpers } from "@vuelidate/validators";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { validPhoneNumber } from "@/helpers/validation";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import store from "@/store";
  import { useToast, POSITION } from "vue-toastification";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import DropdownWithCheckboxes from "@/components/ui/dropdown/DropdownWithCheckboxes.vue";
  import { PlansUserInfoInterface } from "@/types/PlansUserInfoInterface";
  import { PlansStateEnum } from "@/enums/PlansStateEnum";
  import { PlansStatusEnum } from "@/enums/PlansStatusEnum";
  import { PlansSalesToolsEnum } from "@/enums/PlansSalesToolsEnum";
  import { PlansLotRangesEnum } from "@/enums/PlansLotRangesEnum";
  import { PlansStoreFormEnum } from "@/enums/PlansFormEnum";
  import { handleError } from "@/helpers/klaviyo/klaviyo-error-handler.helper";
  import { AxiosError } from "axios";
  import parseAustralianNumberToInternational from "@/helpers/phone-number";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandingForm',
  props: {
    isSignUpView: {}
  },
  emits: ["submit", "signIn"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const toast = useToast();

  const emit = __emit;

  const rules = {
    email: { required, email },
    firstName: { required },
    lastName: { required },
    phoneNumber: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phoneNumber number",
        validPhoneNumber
      ),
    },
    company: { required },
    suburb: { required },
    state: { required },
    lotRanges: { required },
    status: { required },
    salesTools: { required },
    agree: { required },
  };

  const form = reactive<PlansUserInfoInterface>({
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    company: "",
    suburb: "",
    state: "State",
    lotRanges: "Lots",
    status: "Status",
    salesTools: [] as PlansSalesToolsEnum[],
    agree: false,
  });

  const v$ = useVuelidate(rules, form);
  const isLoading = ref(false);

  const optionsBuyerState = [
    PlansStateEnum.NSW,
    PlansStateEnum.QLD,
    PlansStateEnum.SA,
    PlansStateEnum.VIC,
    PlansStateEnum.NT,
    PlansStateEnum.WA,
    PlansStateEnum.ACT,
    PlansStateEnum.TAS,
  ];

  const optionsPlansStatus = [
    PlansStatusEnum.NOW_SELLING,
    PlansStatusEnum.PREPARING_TO_LAUNCH,
    PlansStatusEnum.PLANNING,
  ];

  const optionsPlansSalesTools = [
    { label: "REX", value: PlansSalesToolsEnum.REX },
    { label: "Agent Box", value: PlansSalesToolsEnum.AGENT_BOX },
    { label: "Vault Re", value: PlansSalesToolsEnum.VAULT_RE },
    { label: "Sales Force", value: PlansSalesToolsEnum.SALES_FORCE },
    { label: "Excel", value: PlansSalesToolsEnum.EXCEL },
    { label: "Other", value: PlansSalesToolsEnum.OTHER },
  ];

  const optionsPlansLotRanges = [
    PlansLotRangesEnum.LESS_THAN_20,
    PlansLotRangesEnum.BETWEEN_20_AND_50,
    PlansLotRangesEnum.BETWEEN_50_AND_100,
    PlansLotRangesEnum.BETWEEN_100_AND_200,
    PlansLotRangesEnum.BETWEEN_200_AND_500,
    PlansLotRangesEnum.MORE_THAN_500,
  ];

  const selectBuyerState = (buyerState: PlansStateEnum) => {
    form.state = buyerState;
  };

  const selectPlansStatus = (plansStatus: PlansStatusEnum) => {
    form.status = plansStatus;
  };

  const updateSalesTools = (selectedOptions: PlansSalesToolsEnum[]) => {
    form.salesTools = selectedOptions;
  };

  const selectPlansLotRange = (lotRange: PlansLotRangesEnum) => {
    form.lotRanges = lotRange;
  };

  const getFormParams = (): PlansUserInfoInterface => {
    return {
      ...form,
      phoneNumber: parseAustralianNumberToInternational(form.phoneNumber),
    };
  };

  const submitForm = async () => {
    const isValid = await v$.value.$validate();

    if (!isValid) {
      toast.error("Please fill all required fields correctly.", {
        position: POSITION.TOP_LEFT,
      });
      return;
    }

    if (!form.agree) {
      toast.error(
        "You must agree to the Terms of Service and Privacy Policy.",
        {
          position: POSITION.TOP_LEFT,
        }
      );
      return;
    }

    resetVuelidateErrors(v$);

    const params = getFormParams();

    isLoading.value = true;

    try {
      await store.dispatch(
        `subscription/${
          props.isSignUpView
            ? PlansStoreFormEnum.GET_STARTED
            : PlansStoreFormEnum.JOIN_WAITLIST
        }`,
        params
      );
      emit("submit");
    } catch (error) {
      handleError(error as AxiosError);
    } finally {
      isLoading.value = false;
    }
  };

  const onSingIn = () => emit("signIn");

const __returned__ = { props, toast, emit, rules, form, v$, isLoading, optionsBuyerState, optionsPlansStatus, optionsPlansSalesTools, optionsPlansLotRanges, selectBuyerState, selectPlansStatus, updateSalesTools, selectPlansLotRange, getFormParams, submitForm, onSingIn, reactive, ref, get useVuelidate() { return useVuelidate }, get required() { return required }, get email() { return email }, get helpers() { return helpers }, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get validPhoneNumber() { return validPhoneNumber }, get resetVuelidateErrors() { return resetVuelidateErrors }, get store() { return store }, get useToast() { return useToast }, get POSITION() { return POSITION }, DropDown, DropdownWithCheckboxes, get PlansUserInfoInterface() { return PlansUserInfoInterface }, get PlansStateEnum() { return PlansStateEnum }, get PlansStatusEnum() { return PlansStatusEnum }, get PlansSalesToolsEnum() { return PlansSalesToolsEnum }, get PlansLotRangesEnum() { return PlansLotRangesEnum }, get PlansStoreFormEnum() { return PlansStoreFormEnum }, get handleError() { return handleError }, get AxiosError() { return AxiosError }, get parseAustralianNumberToInternational() { return parseAustralianNumberToInternational } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})